import {
  ADS_CAMPAIGNS_TITLE,
  COMPETITOR_SCOPE_MENU_ITEM,
  GALLERY_TITLE,
  GLOBAL_REPORT_MENU_ITEM,
  HOME_MENU_ITEM,
  SETTINGS_TITLE,
} from "../i18n/keysTranslations";
import {
  ROLES_ALLOWED,
  ROUTE_CAMPAIGNS,
  ROUTE_HOME,
} from "../utils/constants";
import ButtonOpenGallery from "../components/Buttons/ButtonOpenGallery";
import ButtonOpenCalendar from "../components/Buttons/ButtonOpenCalendar";
import ButtonOpenCompetitorScope from "../components/Buttons/ButtonOpenCompetitorScope";
import { Settings, Home } from "lucide-react";
import { Marketing } from "../assets/svg/MenuIcons";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";

const Menus = [
  {
    nameKey: "empty",
    roles: ROLES_ALLOWED,
    subMenus: [
      {
        nameKey: "home",
        name: HOME_MENU_ITEM,
        link: ROUTE_HOME,
        roles: ROLES_ALLOWED,
        icon: <Home size={18} />,
      },
      {
        nameKey: "ads-campaigns",
        name: ADS_CAMPAIGNS_TITLE,
        link: ROUTE_CAMPAIGNS,
        activePathPrefix: "/ads-campaign",
        roles: ROLES_ALLOWED,
        icon: <Marketing className="w-5 h-5" />,
      },
      {
        nameKey: "global-report",
        name: GLOBAL_REPORT_MENU_ITEM,
        link: "/report",
        roles: ROLES_ALLOWED,
        icon: (
          <AssessmentOutlinedIcon
            size={18}
            sx={{
              ml: "0px !important",
            }}
          />
        ),
      },
      {
        nameKey: "gallery",
        name: GALLERY_TITLE,
        link: "/gallery",
        roles: ROLES_ALLOWED,
        customComponent: <ButtonOpenGallery />,
      },
      {
        nameKey: "competitor-scope",
        name: COMPETITOR_SCOPE_MENU_ITEM,
        roles: ROLES_ALLOWED,
        customComponent: <ButtonOpenCompetitorScope />,
      },
      {
        nameKey: "calendar",
        name: "calendar",
        roles: ROLES_ALLOWED,
        customComponent: <ButtonOpenCalendar />,
      },
      {
        nameKey: "settings",
        name: SETTINGS_TITLE,
        link: "/settings",
        roles: ROLES_ALLOWED,
        icon: <Settings size={18} />,
        isPinnedBottom: true,
        disabledSelectedStyle: true,
      },
    ],
  },
];
export default Menus;
